<template>
  <v-container>
      <v-row>
        <v-col cols="4">
          <v-select label="Punto" :items="cargas" item-value="id" item-text="name" outlined></v-select>
        </v-col>
        <v-col cols="12">
          <v-data-table :headers="headers">

          </v-data-table>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { Auth } from '../../../classes/Auth';
import { apiv1 } from '../../../libs/apiv1';

const auth = new Auth

export default Vue.extend({
    name: "Variables",
    data: () => ({
      cargas: [],
      variables: [],
      headers: [
        { text: "OK", value: "ok" }
      ]
    }),
    mounted(){
      this.getCargas();
    },
    methods: {
      getCargas: function() {
        apiv1.get(`cargas?project=${auth.getProject().id}`)
        .then(res => (this.cargas = res.data));
      }
    }
})
</script>

<style>

</style>